// removed by extract-text-webpack-plugin
module.exports = {"root":"index-root-t3LnN","stepperGroup":"index-stepperGroup-3nhQb","step":"index-step-ymqXd","stepActive":"index-stepActive-3aMc4","table":"index-table-3kEw2","tableLable":"index-tableLable-1lAtL","tableInput":"index-tableInput-2tHD-","input":"index-input-2os-m","spanColor":"index-spanColor-2fKyX","tableSubmit":"index-tableSubmit-3AouR","complete":"index-complete-3vYwe"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/index.less
// module id = 1051
// module chunks = 2